import React, { ReactNode } from 'react';

import { StripeElementsProvider } from '../../../../shared/components/stripe';
import { PaymentIntent } from '../../../interfaces/checkoutInfo';

type PaymentBlockProps = {
  paymentIntent?: PaymentIntent | null;
  children: ReactNode;
};

const PaymentBlock = ({ paymentIntent, children }: PaymentBlockProps) => {
  if (!paymentIntent) {
    return null;
  }

  return (
    <StripeElementsProvider
      publishableKey={paymentIntent.publishableKey}
      connectedAccountId={paymentIntent.connectedAccountId}
      elementsOptions={{ clientSecret: paymentIntent.clientSecret }}
    >
      {children}
    </StripeElementsProvider>
  );
};

export { PaymentBlock };
